import { env } from 'env';

const NON_PROD_ENVS = ['dev', 'qa', 'uat'];

export const isNonProdEnv = (): boolean =>
  NON_PROD_ENVS.includes(String(env.REACT_APP_ENV ?? '').toLowerCase());
